import { render, staticRenderFns } from "./BackgroundColorSelector.vue?vue&type=template&id=065a86f0&scoped=true&"
import script from "./BackgroundColorSelector.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColorSelector.vue?vue&type=style&index=0&id=065a86f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a86f0",
  null
  
)

export default component.exports